export enum EffectType {
    OPENAI_IMAGE_EDIT = 'openai-image-edit',
    OPENAI_IMAGE_EDIT_OPENROUTER = 'openai-image-edit-openrouter',
    GEMINI_IMAGE_EDIT = 'gemini-image-edit',
    GEMINI_IMAGE_EDIT_OPENROUTER = 'gemini-image-edit-openrouter',
    GEMINI_IMAGE_TRANSFER_STYLE_OPENROUTER = 'gemini-image-transfer-style-openrouter',
    CUTOUT_PRO_RMBG = 'cutout-pro-rmbg',
    CUTOUT_PRO_FACE_CUT_OUT = 'cutout-pro-face-cut-out',
    CUTOUT_PRO_CARTOON_SELFIE = 'cutout-pro-cartoon-selfie',
    REMOVE_BG = 'remove-bg',
    CUSTOMILY_REMOVE_BG = 'customily-remove-bg',
    CUSTOMILY_FACE_CUT_OUT = 'customily-face-cut-out',
    CUSTOMILY_FILTER_EFFECT = 'customily-filter-effect',
    PICWISH_UPSCALE = 'picwish-upscale-effect',
    CUSTOMILY_REMOVE_SOLID_BACKGROUND = 'customily-remove-solid-background',
    CUSTOMILY_COLOR_TO_ALPHA = 'customily-color-to-alpha',
    OPENAI_TEXT_TO_IMAGE = 'openai-text-to-image',
    GEMINI_TEXT_TO_IMAGE = 'gemini-text-to-image',
    OPENROUTER_TEXT_TO_IMAGE = 'openrouter-text-to-image'
}

export const EditableEffectTypes = [
    EffectType.CUTOUT_PRO_CARTOON_SELFIE,
    EffectType.CUTOUT_PRO_FACE_CUT_OUT,
    EffectType.CUTOUT_PRO_RMBG,
    EffectType.CUSTOMILY_FACE_CUT_OUT,
    EffectType.GEMINI_IMAGE_EDIT,
    EffectType.GEMINI_IMAGE_EDIT_OPENROUTER,
    EffectType.GEMINI_IMAGE_TRANSFER_STYLE_OPENROUTER,
    EffectType.OPENAI_IMAGE_EDIT_OPENROUTER,
    EffectType.OPENAI_IMAGE_EDIT,
    EffectType.REMOVE_BG,
    EffectType.PICWISH_UPSCALE,
    EffectType.CUSTOMILY_COLOR_TO_ALPHA,
    EffectType.OPENAI_TEXT_TO_IMAGE,
    EffectType.GEMINI_TEXT_TO_IMAGE,
    EffectType.OPENROUTER_TEXT_TO_IMAGE
];

export const TextToImageEffectTypes: EffectType[] = [
    EffectType.GEMINI_TEXT_TO_IMAGE,
    EffectType.OPENAI_TEXT_TO_IMAGE,
    EffectType.OPENROUTER_TEXT_TO_IMAGE
];

export const isTextToImageEffect = (type: EffectType): boolean => TextToImageEffectTypes.includes(type);

export enum OpenAIQuality {
    HIGH = 'high',
    MEDIUM = 'medium',
    LOW = 'low',
    AUTO = 'auto'
}

export enum OpenAISize {
    SQUARE = '1024x1024',
    LANDSCAPE = '1536x1024',
    PORTRAIT = '1024x1536',
    AUTO = 'auto'
}

export enum OpenAIBackground {
    TRANSPARENT = 'transparent',
    OPAQUE = 'opaque',
    AUTO = 'auto'
}

export enum OpenAIModel {
    GPT_IMAGE_1 = 'gpt-image-1',
    GPT_IMAGE_1_5 = 'gpt-image-1.5',
    GPT_IMAGE_1_MINI = 'gpt-image-1-mini',
    GPT_IMAGE_2 = 'gpt-image-2'
}

export enum CutoutProCartoonType {
    'magic-mirror-avatar' = '0',
    'fairy-avatar' = '1',
    'dreamland-avatar' = '2',
    'manga-avatar' = '3',
    'k-pop-avatar' = '4',
    'k-pop' = '5',
    'pixel' = '6',
    'smile-avatar' = '7',
    'magic-mirror' = '8',
    'american-comic-avatar' = '9',
    'american-comic' = '10',
    'pixar-avatar' = '11_header',
    'pixar' = '11_full',
    'pinky-avatar' = '12_header',
    'pinky' = '12_full',
    '13-header' = '13_header',
    '13-full' = '13_full'
}

export enum CustomilyFilterType {
    aqua = 'aqua',
    pencil = 'pencil',
    blur = 'blur',
    cartoon = 'cartoon',
    edge = 'edge',
    grayscale = 'grayscale',
    hdr = 'hdr',
    invert = 'invert',
    sepia = 'sepia',
    sharpen = 'sharpen',
    sketch = 'sketch',
    white_removal = 'white_removal'
}

export enum RemoveBgQuality {
    HQ = 'hq',
    LQ = 'lq',
    AUTO = 'auto'
}

export enum CutoutProQuality {
    HQ = 'hq',
    LQ = 'lq',
    AUTO = 'auto'
}

export enum PicwishUpScaleFactor {
    AUTO = 'auto',
    X1 = '1',
    X2 = '2',
    X4 = '4'
}

export enum PicwishEnhancementType {
    CLEAN = 'clean',
    FACE = 'face'
}

export enum GeminiImageModelsType {
    GEMINI_2_5_FLASH_IMAGE = 'gemini-2.5-flash-image',
    GEMINI_3_1_FLASH_IMAGE = 'gemini-3.1-flash-image',
    GEMINI_3_PRO_IMAGE = 'gemini-3-pro-image',
    /** @deprecated Usar GEMINI_3_PRO_IMAGE en su lugar */
    GEMINI_3_PRO_IMAGE_PREVIEW = 'gemini-3-pro-image-preview'
}

export enum GeminiAspectRatioType {
    '1:1' = '1:1',
    '2:3' = '2:3',
    '3:2' = '3:2',
    '3:4' = '3:4',
    '4:3' = '4:3',
    '4:5' = '4:5',
    '5:4' = '5:4',
    '9:16' = '9:16',
    '16:9' = '16:9',
    '21:9' = '21:9'
}

export enum GeminiImageSizeType {
    '1K' = '1K',
    '2K' = '2K',
    '4K' = '4K'
}

export interface ImageEffectBase {
    id?: string;
    type: EffectType;
    presetId?: string;
}

export interface OpenAiImageEditType extends ImageEffectBase {
    type: EffectType.OPENAI_IMAGE_EDIT;
    prompt: string;
    quality: OpenAIQuality;
    background: OpenAIBackground;
    size: OpenAISize;
    model: OpenAIModel;
}

export interface OpenAiImageEditOpenRouterType extends ImageEffectBase {
    type: EffectType.OPENAI_IMAGE_EDIT_OPENROUTER;
    prompt: string;
    isMini?: boolean;
}

export interface GeminiImageEditType extends ImageEffectBase {
    type: EffectType.GEMINI_IMAGE_EDIT;
    prompt: string;
    model: GeminiImageModelsType;
    aspectRatio: GeminiAspectRatioType;
    imageSize: GeminiImageSizeType;
}

export enum GeminiTextToImageModel {
    GEMINI_2_5_FLASH_IMAGE = 'gemini-2.5-flash-image',
    GEMINI_3_1_FLASH_IMAGE = 'gemini-3.1-flash-image',
    GEMINI_3_PRO_IMAGE_PREVIEW = 'gemini-3-pro-image-preview',
    GEMINI_3_PRO_IMAGE = 'gemini-3-pro-image'
}

export enum GeminiTextToImageAspectRatio {
    '1:1' = '1:1',
    '2:3' = '2:3',
    '3:2' = '3:2',
    '3:4' = '3:4',
    '4:3' = '4:3',
    '4:5' = '4:5',
    '5:4' = '5:4',
    '9:16' = '9:16',
    '16:9' = '16:9',
    '21:9' = '21:9'
}

export enum GeminiTextToImageSize {
    '1K' = '1K',
    '2K' = '2K',
    '4K' = '4K'
}

export interface GeminiTextToImageType extends ImageEffectBase {
    type: EffectType.GEMINI_TEXT_TO_IMAGE;
    model: GeminiTextToImageModel;
    aspectRatio: GeminiTextToImageAspectRatio;
    imageSize: GeminiTextToImageSize;
}

export enum OpenAiTextToImageModel {
    GPT_IMAGE_1 = 'gpt-image-1',
    GPT_IMAGE_1_5 = 'gpt-image-1.5',
    GPT_IMAGE_1_MINI = 'gpt-image-1-mini',
    GPT_IMAGE_2 = 'gpt-image-2'
}

export enum OpenAiTextToImageQuality {
    HIGH = 'high',
    MEDIUM = 'medium',
    LOW = 'low',
    AUTO = 'auto'
}

export enum OpenAiTextToImageBackground {
    TRANSPARENT = 'transparent',
    OPAQUE = 'opaque',
    AUTO = 'auto'
}

export enum OpenAiTextToImageSize {
    SQUARE = '1024x1024',
    LANDSCAPE = '1536x1024',
    PORTRAIT = '1024x1536',
    AUTO = 'auto'
}

export interface OpenAiTextToImageType extends ImageEffectBase {
    type: EffectType.OPENAI_TEXT_TO_IMAGE;
    model: OpenAiTextToImageModel;
    quality: OpenAiTextToImageQuality;
    background: OpenAiTextToImageBackground;
    size: OpenAiTextToImageSize;
}

export enum OpenRouterTextToImageGeminiModel {
    GEMINI_2_5_FLASH_IMAGE = 'gemini-2.5-flash-image',
    GEMINI_3_1_FLASH_IMAGE = 'gemini-3.1-flash-image',
    GEMINI_3_PRO_IMAGE = 'gemini-3-pro-image'
}

export enum OpenRouterTextToImageOpenAIModel {
    GPT_IMAGE_1 = 'openai/gpt-image-1',
    GPT_IMAGE_1_5 = 'openai/gpt-image-1.5',
    GPT_IMAGE_1_MINI = 'openai/gpt-image-1-mini',
    GPT_IMAGE_2 = 'openai/gpt-image-2'
}

export enum OpenRouterTextToImageBackground {
    TRANSPARENT = 'transparent',
    OPAQUE = 'opaque',
    AUTO = 'auto'
}

export enum OpenRouterTextToImageQuality {
    HIGH = 'high',
    MEDIUM = 'medium',
    LOW = 'low',
    AUTO = 'auto'
}

export enum OpenRouterTextToImageSize {
    SQUARE = '1024x1024',
    LANDSCAPE = '1536x1024',
    PORTRAIT = '1024x1536',
    LANDSCAPE_WIDE = '1792x1024',
    PORTRAIT_WIDE = '1024x1792',
    AUTO = 'auto'
}

export interface OpenRouterGeminiTextToImageType extends ImageEffectBase {
    type: EffectType.OPENROUTER_TEXT_TO_IMAGE;
    model: OpenRouterTextToImageGeminiModel;
    size: OpenRouterTextToImageSize;
}

export interface OpenRouterOpenAiTextToImageType extends ImageEffectBase {
    type: EffectType.OPENROUTER_TEXT_TO_IMAGE;
    model: OpenRouterTextToImageOpenAIModel;
    background: OpenRouterTextToImageBackground;
    quality: OpenRouterTextToImageQuality;
    size: OpenRouterTextToImageSize;
}

export type OpenRouterTextToImageType = OpenRouterGeminiTextToImageType | OpenRouterOpenAiTextToImageType;

export interface GeminiImageEditOpenRouterType extends ImageEffectBase {
    type: EffectType.GEMINI_IMAGE_EDIT_OPENROUTER;
    prompt: string;
    isFree?: boolean;
    isMini?: boolean;
}

export interface GeminiImageTransferStyleOpenRouterType extends ImageEffectBase {
    type: EffectType.GEMINI_IMAGE_TRANSFER_STYLE_OPENROUTER;
    prompt: string;
    referenceImageUrl: string;
    isFree?: boolean;
}

export interface CutoutProRmbgType extends ImageEffectBase {
    type: EffectType.CUTOUT_PRO_RMBG;
    bgColor: string;
    crop: boolean;
    cropMargin: string;
    quality: CutoutProQuality;
}

export interface CutoutProFaceCutOutType extends ImageEffectBase {
    type: EffectType.CUTOUT_PRO_FACE_CUT_OUT;
    bgColor: string;
    crop: boolean;
    quality: CutoutProQuality;
    faceAnalysis?: boolean;
}

export interface CutoutProCartoonSelfieType extends ImageEffectBase {
    type: EffectType.CUTOUT_PRO_CARTOON_SELFIE;
    cartoonType: CutoutProCartoonType;
}

export interface RemoveBgType extends ImageEffectBase {
    type: EffectType.REMOVE_BG;
    bgColor: string;
    crop: boolean;
    cropMargin: string;
    quality: RemoveBgQuality;
}

export interface CustomilyRemoveBgType extends ImageEffectBase {
    type: EffectType.CUSTOMILY_REMOVE_BG;
}

export interface CustomilyFaceCutOutType extends ImageEffectBase {
    type: EffectType.CUSTOMILY_FACE_CUT_OUT;
    faceAnalysis?: boolean;
}

export interface CustomilyRemoveSolidBackgroundType extends ImageEffectBase {
    type: EffectType.CUSTOMILY_REMOVE_SOLID_BACKGROUND;
}

export interface CustomilyColorToAlphaType extends ImageEffectBase {
    type: EffectType.CUSTOMILY_COLOR_TO_ALPHA;
    color: string; // hex: #RGB | #RRGGBB | #RRGGBBAA (matches storefront PR #4979 schema)
    tolerance?: number; // integer 0-442, default 20
}

export interface CustomilyFilterEffectType extends ImageEffectBase {
    type: EffectType.CUSTOMILY_FILTER_EFFECT;
    filterType: CustomilyFilterType;
}

export interface PicwishUpScaleEffectType extends ImageEffectBase {
    type: EffectType.PICWISH_UPSCALE;
    scaleFactor: PicwishUpScaleFactor;
    enhancementType: PicwishEnhancementType;
}

export type ImageEffectType =
    | OpenAiImageEditType
    | OpenAiImageEditOpenRouterType
    | GeminiImageEditType
    | GeminiImageEditOpenRouterType
    | GeminiImageTransferStyleOpenRouterType
    | CutoutProRmbgType
    | CutoutProFaceCutOutType
    | CutoutProCartoonSelfieType
    | RemoveBgType
    | CustomilyRemoveBgType
    | CustomilyFaceCutOutType
    | CustomilyFilterEffectType
    | CustomilyRemoveSolidBackgroundType
    | CustomilyColorToAlphaType
    | PicwishUpScaleEffectType
    | GeminiTextToImageType
    | OpenAiTextToImageType
    | OpenRouterTextToImageType;
